import { render } from "./Kanban.vue?vue&type=template&id=6dd062d6&scoped=true&ts=true"
import script from "./Kanban.vue?vue&type=script&lang=ts"
export * from "./Kanban.vue?vue&type=script&lang=ts"

import "./Kanban.vue?vue&type=style&index=0&id=6dd062d6&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd062d6"]])

export default __exports__